// Environment variables for the frontend
// This file provides a centralized way to access environment variables in the React app

// API URL - use the environment variable if available, otherwise fall back to a default
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://beta.ibot.studio';

// Other environment variables can be added here as needed
export const ENV = {
  NODE_ENV: process.env.NODE_ENV || 'development',
  // Add more as needed
};